import React, { useEffect, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { IncidentReport } from "../../redux/admin/actions/admin.actions";
import Style from "./IncidentReport.module.scss";
import IncidentModal from "./IncidentModal";
import { Table } from "react-bootstrap";
import { LinearLoader } from "../../components/Loader/LinearLoader";

const IncidentReportScreen = () => {
  const [incidents, setIncident] = useState(false);
  const [loading, setLoading] = useState(false);
  const [selectedIncident, setSelectedIncident] = useState(null);

  const { incidentReport } = useSelector((state) => state.adminReducer);
  const dispatch = useDispatch();

  useEffect(() => {
    setLoading(true);
    dispatch(IncidentReport());
    setLoading(false);
  }, [dispatch]);

  const headers = [
    { key: "id", label: "Id" },
    { key: "orders", label: "Orders" },
    { key: "blood", label: "Blood" },
    { key: "reason", label: "Reason" },
    { key: "dispatch", label: "Dispatch" },
    { Key: "time", label: "Time" },
    { key: "status", label: "Status" },
    {key: "feedback", label: "Feedback"}
  ];

  const handleReport = (incident) => {
    setIncident(true);
    setSelectedIncident(incident);
  };

  return (
    <div>
      {incidents && (
        <IncidentModal setIncident={setIncident} incident={selectedIncident} />
      )}
      <h2>Incident Report</h2>
      <section style={{ maxWidth: "90%", margin: "auto", boxShadow: "1px 2px 10px rgba(112, 144, 176, 0.25)"}}>
        {loading && <LinearLoader />}
        <Table borderless responsive className="" hover>
          <thead>
            <tr className={Style.TableHeadRow}>
              {headers.map((header) => (
                <th key={header.key}>{header.label}</th>
              ))}
            </tr>
          </thead>
          <tbody>
            {incidentReport?.map((incident) => (
              <tr key={incident.id}>
                <td
                  style={{
                    width: "7vw",
                    verticalAlign: "middle",
                    padding: "10px",
                  }}
                >
                  {String(incident.id)}
                </td>
                <td
                  style={{
                    width: "7vw",
                    verticalAlign: "middle",
                    padding: "10px",
                  }}
                >
                  {String(incident.orders)}
                </td>
                <td
                  style={{
                    width: "7vw",
                    verticalAlign: "middle",
                    padding: "10px",
                  }}
                >
                  {String(incident.blood)}
                </td>
                <td
                  style={{
                    width: "7vw",
                    verticalAlign: "middle",
                    padding: "10px",
                  }}
                >
                  {String(incident.reason)}
                </td>
                <td
                  style={{
                    width: "7vw",
                    verticalAlign: "middle",
                    padding: "10px",
                  }}
                >
                  {String(incident.dispatch)}
                </td>
                <td
                  style={{
                    width: "7vw",
                    verticalAlign: "middle",
                    padding: "10px",
                  }}
                >
                  {String(incident.created)}
                </td>
                <td
                  style={{
                    width: "7vw",
                    verticalAlign: "middle",
                    padding: "10px",
                  }}
                >
                  {incident.status}
                </td>
                <td style={{ width: "15vw" }}>
                  <button
                    className={`${Style.btn}`}
                    onClick={() => handleReport(incident)}
                  >
                    Respond
                  </button>
                </td>
              </tr>
            ))}
          </tbody>
        </Table>
      </section>
    </div>
  );
};

export default IncidentReportScreen;
